import { render, staticRenderFns } from "./teacherDataDelete.vue?vue&type=template&id=335f69f7&"
import script from "./teacherDataDelete.vue?vue&type=script&lang=js&"
export * from "./teacherDataDelete.vue?vue&type=script&lang=js&"
import style0 from "./teacherDataDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports